import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import commonStyles from '../../pages/styles.css';

export default function PageTitle(props) {
  const { icon, children } = props;

  return <>
    <header className={commonStyles.header}>

      <Avatar className={commonStyles.iconAvatar}>
        {icon}
      </Avatar>

      <Typography component="h2" variant="h4" gutterBottom>
        {children}
      </Typography>
    </header>

    <Divider className={commonStyles.headerDivider} />
    </>;
}
